import { defineComponent as _defineComponent } from 'vue'
import { GET } from '@/admin-shared-modules/utils/ajax'
import { orderBy } from 'lodash'
import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const pickerOptions = {
  disabledDate(time) {
    return time.getFullYear() < 2020 || time.getFullYear() > 2030
  }
}

const date = ref(new Date())
const isLoading = ref(false)
watch(
  date,
  () => {
    fetch(date.value.getFullYear())
  },
  {
    immediate: true
  }
)

const data = ref([])

async function fetch(year: number) {
  isLoading.value = true
  const res = await GET('monthly_records/list', {
    data: { year }
  })
  data.value = orderBy(res.data, 'month')
  isLoading.value = false
}

return { __sfc: true,pickerOptions, date, isLoading, data, fetch }
}

})